import { TimeUser } from '../../../../api/generated/data-contracts';
import { FunctionOr } from '../../../../types/FunctionOr';

export const isUserChanged = (originalUser: TimeUser, currentUser: TimeUser) => {
    if (
        currentUser.userNumber?.toString() !== originalUser.userNumber?.toString() ||
        currentUser.availability?.toString() !== originalUser.availability?.toString()
    ) {
        return true;
    }
    // else if (currentUser.availability?.toString() !== originalUser.availability?.toString()) {
    //     return true;
    // }
    return false;
};

export interface IUpdateUserProps {
    user: TimeUser;
    setUser: (update: FunctionOr<TimeUser>) => void;
}

export const resourceListColumns = [
    {
        key: 'name',
        name: 'Name',
        isRowHeader: true,
        fieldName: 'name',
        minWidth: 175,
        maxWidth: 300,
        isResizable: true,
        isSorted: true,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
    },
    {
        key: 'email',
        name: 'E-Mail',
        fieldName: 'email',
        minWidth: 175,
        maxWidth: 300,
        isPadded: false,
        isSorted: false,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
    },
    {
        key: 'calendar',
        name: 'Calendar',
        fieldName: 'calendar',
        minWidth: 100,
        maxWidth: 150,
        isPadded: false,
        isSorted: false,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
    },
    {
        key: 'start',
        name: 'Earliest Available',
        fieldName: 'start',
        minWidth: 150,
        maxWidth: 200,
        isPadded: false,
        isSorted: false,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
    },
    {
        key: 'end',
        name: 'Latest Available',
        fieldName: 'end',
        minWidth: 150,
        maxWidth: 200,
        isPadded: false,
        isSorted: false,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
    },
    {
        key: 'capacity',
        name: 'Daily Capacity (Hours)',
        fieldName: 'capacity',
        minWidth: 150,
        maxWidth: 200,
        isResizable: true,
        isPadded: false,
        isSorted: false,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
    },
    {
        key: 'userNumber',
        name: 'User Number',
        fieldName: 'userNumber',
        minWidth: 175,
        maxWidth: 300,
        isResizable: true,
        isPadded: false,
        isSorted: false,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
    },
    {
        key: 'state',
        name: 'State',
        fieldName: 'state',
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
        isPadded: false,
        isSorted: false,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
    },
    {
        key: 'update',
        name: '',
        fieldName: 'update',
        minWidth: 50,
        isResizable: true,
        isPadded: false,
    },
];
